import { ColorTokens } from "../styles/Global.style";

export const theme = {
  color: {
    primary: `var(${ColorTokens.Primary})`, // Purple
    primaryChill: `var(${ColorTokens.PrimaryChill})`, // Purple chill
    primaryDark: `var(${ColorTokens.PrimaryDark})`, // Purple Dark
    primaryLight: `var(${ColorTokens.PrimaryLight})`, // Purple Light
    primaryExtraLight: `var(${ColorTokens.PrimaryExtraLight})`, // Extra Light Purple

    tertiary: "#f45c65", // Red
    tertiaryLight: `var(${ColorTokens.TertiaryLight})`, // Light Red

    textSecondary: `var(${ColorTokens.GreyMedium})`, // Grey

    success: `var(${ColorTokens.Success})`, // green

    inputLabel: `var(${ColorTokens.TertiaryLight})`,
    inputError: `var(${ColorTokens.TertiaryLight})`,
    inputBackground: `var(${ColorTokens.PrimaryExtraLight})`,
  },
  font: {
    family: {
      main: "Rethink Sans",
      title: "Poppins",
      label: "DynaPuff",
    },
    size: {
      title: {
        small: "1.2rem",
        medium: "1.4rem",
        big: "1.8rem",
        xbig: "3rem",
        xxbig: "4rem",
      },
    },
    elevation: {
      medium: "3px 3px 5px rgba(0, 0, 0, 0.1)",
      big: "10px 10px 20px rgba(0, 0, 0, 0.2)",
      hard: {
        big: "3px 3px 0 rgba(0, 0, 0, 0.4)",
        small: "1.5px 1.5px 0 rgba(0, 0, 0, 0.4)",
      },
      dogName: "5px 5px 0 rgba(101, 98, 223, 0.4)",
    },
  },
  rootContainerInlinePadding: "1rem",
  rootContainerBlockPadding: "2rem",
};
